// App.tsx
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './components/Header';
import FooterNew from './components/FooterNew';
import StickySocialIcons from './components/StickySocialIcons';
import PageIndicator from './components/PageIndicator';
import Home from './pages/Home';
import AnimatedBackground from './components/AnimatedBackground';

const App: React.FC = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setMousePosition({ x: e.clientX, y: e.clientY });

      // Update CSS custom properties for cursor glow
      const root = document.documentElement;
      root.style.setProperty('--cursor-x', `${e.clientX}px`);
      root.style.setProperty('--cursor-y', `${e.clientY}px`);
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-beige text-espresso relative">
        <AnimatedBackground />
        {/* Cursor glow effect */}
        <div
          className="pointer-events-none fixed w-96 h-96 rounded-full opacity-20 blur-3xl mix-blend-screen z-40"
          style={{
            background: 'radial-gradient(circle, rgba(197, 123, 87, 0.4) 0%, rgba(197, 123, 87, 0) 70%)',
            left: `${mousePosition.x - 192}px`,
            top: `${mousePosition.y - 192}px`,
            transition: 'all 0.15s ease-out'
          }}
        />
        {/* Sticky Social Icons */}
        <StickySocialIcons />
        {/* Page Indicator */}
        <PageIndicator />
        <Header />
        <main className="flex-grow relative z-10 md:pt-0 pt-16">
          <Home />
        </main>
        <FooterNew />
      </div>
    </Router>
  );
};

export default App;